export default __webpack_public_path__ + "static/media/pogot-mobile-2.d06361f1.png";